import * as React from 'react'
import Header from '../structure/Header/Header'
import Footer from '../structure/Footer/Footer'
import Table from 'react-bootstrap/Table'
import ApiCall from '../../components/ApiCall/ApiCall'
require('../Cgu/cgu.css')
/*
	this class is the historic page
	user can find here the list of all research using our website with a link to more details.
*/
interface HistoriqueState {
	history_tab : any
	error:boolean
	message:string
	url:string
	result:string
}
interface HistoriqueProps {
}

export default class Historique extends React.Component<HistoriqueProps, HistoriqueState> {
	private api = new ApiCall()

	constructor(props: HistoriqueProps){
		super(props)
		this.state = {
            history_tab : [],
			error : false,
			message:"",
			result:"",
			url:"https://privasee.netlify.app/clauses?site="
        };
	}

	componentDidMount = async () => {
		const request = await this.api.ApiCall("logs/history", "GET", {}, localStorage.getItem('AccessToken'))
		if(request.status === 200)
		{
			this.setState({
				history_tab : request.data
			})
		}
		else {
			this.setState({
                error: true,
                message: request.data.message
            })
		}
	}

	render() {
		return (
			<>	
				<div id="other_canv">
					<div id="particles-js">
					<Header/>
					<div className="hero-wrap js-fullheight">
						<div className="overlay">
						</div>
							<div className="container">
								<div className="row no-gutters slider-text align-items-center justify-content-center" data-scrollax-parent="true">
									<div id="border-search" className="col-md-6 ftco-animate text-center fadeInUp ftco-animated" data-scrollax=" properties: { translateY: '70%' }">
										<br></br>
										<br></br>
										<h1 className="mb-3 bread" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
											Historique
										</h1>
									</div>
								</div>
							</div>
						</div>
					</div>
				<section>
                <Table striped bordered hover>
                <thead>
                    <tr>
                    <th>#</th>
                    <th>Site(s) visité(s)</th>
                    <th>Lien(s)</th>
                    </tr>
                </thead>
                <tbody>
				{this.state.history_tab.map((result:string,index:number)=>
				<tr>
				<td>{index + 1}</td>
				<td>{this.state.history_tab[index].result}</td>
				<td><a href={this.state.url + this.state.history_tab[index].result}>lien</a> </td>
				</tr>
				)}
                   
                </tbody>
                </Table>
				</section>
				
				<Footer/>
				</div>
			</>
		);
	}

}